import React from 'react';
import ReactDOM from 'react-dom';
import Raven from 'raven-js';

import {Provider} from 'react-redux';
import createReduxStore from 'configureStore';
import reducer from 'reducer';

import App from "./App";

import L from 'leaflet';

// BUG https://github.com/Leaflet/Leaflet/issues/4968
import iconRetinaUrl from 'leaflet/dist/images/marker-icon-2x.png'
import iconUrl from 'leaflet/dist/images/marker-icon.png'
import shadowUrl from 'leaflet/dist/images/marker-shadow.png'

L.Marker.prototype.options.icon = L.icon({
    iconRetinaUrl,
    iconUrl,
    shadowUrl,
    iconSize: [25, 41],
    iconAnchor: [12, 41],
    popupAnchor: [1, -34],
    tooltipAnchor: [16, -28],
    shadowSize: [41, 41]
});


// Install Raven in production envs
if (process.env.NODE_ENV === 'production') {
    Raven.config(DJ_CONST.RAVEN_PUBLIC_DSN).install(); // eslint-disable-line
    // handle rejected promises
    window.addEventListener('unhandledrejection', (evt) => {
        Raven.captureException(evt.reason);
    });
    // If we have authenticated user, pass its data on to Raven
    if (DJ_CONST.user) {
        Raven.setUserContext({
            id: DJ_CONST.user.id,
            email: DJ_CONST.user.email,
            name: DJ_CONST.user.name,
        });
    }
}


function init() {
    const elem = document.getElementById("app-container");
    if (!elem) {
        return;
    }

    const store = createReduxStore(reducer);

    ReactDOM.render(
        (
            <Provider store={store}>
                <App />
            </Provider>
        ), elem
    );
}


export {init}; // eslint-disable-line import/prefer-default-export



// WEBPACK FOOTER //
// ./src/main.js